import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from '../../util/reactIntl';

import FileUploadField from '../../components/FilesUploadField/FileUploadField';

import css from './EditListingOfferDescriptionForm.module.css';
import { FieldTextInput } from '../../components';

const MAX_FILE_SIZE = '5mb'

const FilesField = (props) => {
  const {
    fieldName,
    label,
    tip,
    mutatorsPush,
    placeholder,
    isDocumentField,
    usePreviewIcon
  } = props;

  return (
    <div className={css.filesField} id="documents">
      <p className={css.dynamicItemLabel}>
        {label}
        {tip}
      </p>
      <p className={css.fieldLabelTip}>
        <FormattedMessage id="EditListingPage.uploadFileInfo" values={{maxFileSize: MAX_FILE_SIZE}} />
      </p>
      <div className={css.fileFieldsWrapper}>
        <FieldArray name={fieldName}>
          {({ fields }) => {
            return fields.map((name, index) => {
              
              const defaultFields = !!fields.value[index] ? (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                  <FieldTextInput
                    key={`${name}.description`}
                    id={`${name}.description`}
                    name={`${name}.description`}
                    type="text"
                    placeholder={placeholder || null}
                  />
                </div>
              ) : (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                </div>
              );

              const content = isDocumentField ? (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                </div>
              ) : (
                defaultFields
              );

              return content
            });
          }}
        </FieldArray>
      </div>
    </div>
  );
};

export default FilesField;
